export default __webpack_public_path__ + "66c10330c394d0333cb27a1c62256b04.png";